import useDisableBodyScroll from 'fitify-ui/src/hooks/useDisableBodyScroll'
import { useDisclosure } from 'fitify-ui/src/hooks/useDisclosure'
import { useOnClickOutside } from 'fitify-ui/src/hooks/useOnClickOutside'
import { useCallback, useEffect, useRef } from 'react'

export const useModal = (
  isOpenDefault = false,
  preventAutomaticOnCloseFeatures = false
) => {
  const { isOpen, handleOpen, handleClose, handleToggle } =
    useDisclosure(isOpenDefault)
  const modalRef = useRef<HTMLDivElement | null>(null)

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        !preventAutomaticOnCloseFeatures && handleClose()
      }
    },
    [handleClose, preventAutomaticOnCloseFeatures]
  )

  useOnClickOutside(
    [modalRef],
    !preventAutomaticOnCloseFeatures
      ? handleClose
      : () => {
          /* empty */
        }
  )
  useDisableBodyScroll(isOpen)

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyPress)
      return () => {
        document.removeEventListener('keydown', handleKeyPress)
      }
    }
    return undefined
  }, [isOpen, handleKeyPress])

  return {
    handleClose,
    handleOpen,
    handleToggle,
    isOpen,
    modalRef,
  }
}
